import { render } from "./CompraS.vue?vue&type=template&id=0f75e67a&scoped=true"
import script from "./CompraS.vue?vue&type=script&lang=js"
export * from "./CompraS.vue?vue&type=script&lang=js"

import "./CompraS.vue?vue&type=style&index=0&id=0f75e67a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f75e67a"]])

export default __exports__